import { TextMap } from "../../types";

const fa: TextMap = {
  choose_preferred_wallet: "کیف پول مورد نظر خود را انتخاب کنید",
  connect_mobile_wallet: "به کیف پول موبایل وصل شوید",
  scan_qrcode_with_wallet: "کد QR را با یک کیف پول سازگار با WalletConnect اسکن کنید",
  connect: "اتصال",
  // TODO: review following translations
  qrcode: "کد QR",
  mobile: "سیار",
  copy_to_clipboard: "کپی به کلیپ بورد",
  copied_to_clipboard: "در کلیپ بورد کپی شد!",
  show_more: "بیشتر نشان بده، اطلاعات بیشتر",
  show_less: "نمایش کمتر",
};

export default fa;
